const translations = {
    es: {
        "duplicate-suffix": "(copia)",
        "duplicate-ok-title": "Duplicada",
        "duplicate-ok-text": "Se ha duplicado la ruta",
        "duplicate-error": "No se ha podido duplicar la ruta",
    },
    en: {
        "duplicate-suffix": "(copy)",
        "duplicate-ok-title": "Duplicated",
        "duplicate-ok-text": "The route has been duplicated",
        "duplicate-error": "The route could not be duplicated",
    },
};

export default translations;
